export default __webpack_public_path__ + "static/media/bolt.64e7d9d3.png";